import axios from 'axios';
import type { MenuItem } from '../domain/interfaces/cardapio';

const API_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:3000/api';

interface ComboItemResponse {
  itemId: string;
  quantidade: number;
  nomeItemSnapshot?: string;
  precoUnitarioSnapshot?: number;
}

interface ComboResponse {
  id: string;
  cnpj: string;
  nome: string;
  descricao?: string;
  categoria: string;
  itens: ComboItemResponse[];
  precoBase: number;
  precoPromocional?: number;
  ativo: boolean;
  ordem?: number;
  imagePath?: string;
  imageUrl?: string;
}

export const fetchCombos = async (cnpj: string): Promise<MenuItem[]> => {
  const response = await axios.get<ComboResponse[]>(`${API_URL}/combos`, {
    params: { cnpj, onlyActive: true },
  });

  return response.data
    .filter((combo) => combo.ativo)
    .map<MenuItem>((combo) => ({
      id: combo.id,
      name: combo.nome,
      description: combo.descricao ?? '',
      // Usa preço promocional se existir, senão o preço base
      price: combo.precoPromocional ?? combo.precoBase,
      category: 'combos',
      newItem: false,
      flavors: [],
      comboItems: combo.itens?.map((item) => ({
        itemId: item.itemId,
        quantity: item.quantidade,
        name: item.nomeItemSnapshot,
        price: item.precoUnitarioSnapshot,
      })),
      image: combo.imageUrl,
    }));
};
